import PropTypes from 'prop-types'
import React from 'react'
import { isJsonString } from 'src/utils/Utils'

const getItemValue = (value, unit) => {
  if (isJsonString(value) && Array.isArray(JSON.parse(value))) {
    return <span>{JSON.parse(value).join(', ')}{unit}</span>
  }

  if (Array.isArray(value)) {
    return <span>{value.map(item => [item, <br />])}</span>
  }

  return <span>{value}{unit}</span>
}

export const Item = ({property, value, unit}) => {
  if (!value || (Array.isArray(value) && !value.length)) return null

  return (
    <li>
      <p>{property}:</p>
      {getItemValue(value, unit)}
    </li>
  )
}

Item.propTypes = {
  property: PropTypes.string,
  value: PropTypes.string,
  unit: PropTypes.string
}
